// extracted by mini-css-extract-plugin
module.exports = {"container":"container--ZGij2","body":"body--2KRf_","loading":"loading--3WRgq","backtop":"backtop--QFcIq"};